// extracted by mini-css-extract-plugin
export default {"linkNotValidPageWrapper":"styles_linkNotValidPageWrapper__YpY6C","pageContent":"styles_pageContent__9YrCs","textBlock":"styles_textBlock__9LdNs"};